import { TableCompData } from "../../../../components";
import EmptyTable from "../../../../components/Common/EmptyTable";
import TableSkeletonLoader from "../../../../components/Common/TableSkeletonLoader";
import { SettingRoleManagementHeader } from "../../../../utils/TableHeader";
import { useGetRolesQuery } from "../../../../store/admin/settings/roleSlice";
import { useMemo } from "react";
import { dateFromString } from "../../../../utils";

export default function AllRoleManagement({
  TableDropDown,
  onSubmit,
  emptyTable,
}) {
  const { data = [], error, isFetching } = useGetRolesQuery();
  const tableData = useMemo(() => {
    return (data || [])
      .filter((item) => item && item.id)
      .map((item, index) => ({
        ...item,
        date: dateFromString(item?.created_at),
        serialNumber: index + 1,
      }));
  }, [data]);

  if (error) {
    console.error(error);
  }

  return (
    <div>
      <div className="mb-5 pb-10">
        <TableCompData
          marginBottom={"10"}
          columns={SettingRoleManagementHeader(TableDropDown)}
          data={tableData}
          progressPending={isFetching}
          progressComponent={<TableSkeletonLoader rows={8} columns={4} />}
          message={
            isFetching ? null : (
              <EmptyTable
                Message={emptyTable || "No roles have been created yet"}
                btnText={"Create new"}
                onClick={onSubmit}
              />
            )
          }
        />
      </div>
    </div>
  );
}
